
import {isValidElement, ReactElement} from "react";
import {ManagedTabProps} from "./ManagedTabProps";

export function isManagedTabElement(
  arg: any
): arg is ReactElement<ManagedTabProps> {
  // prettier-ignore
  const valid = isValidElement<ManagedTabProps>(arg)
        && !!arg.props.tabId
        && !!arg.props.label;
  if (!valid) {
    console.warn("Detected an invalid ManagedTab child");
  }
  return valid;
}
